import { FiCheckCircle } from "react-icons/fi";
import clsx from "clsx";
import PlayBillingSubscription from "./PlayBillingSubscription";

interface PlanCardProps {
  type: "free" | "premium";
  title: string;
  price: string;
  description: string;
  features: string[];
  isHighlighted?: boolean;
  isPlayBillingAvailable?: boolean;
  user?: any;
}

export default function PlanCard({
  type,
  title,
  price,
  description,
  features,
  isHighlighted = false,
  isPlayBillingAvailable = false,
  user
}: PlanCardProps): JSX.Element {
  const signupUrl = "/cadastro?redirect_to=/assinatura";

  const renderSubscriptionButton = () => {
    if (!user) {
      return (
        <a href={signupUrl} className="duration-200 btn btn-primary block">
          Assinar Agora
        </a>
      );
    }

    if (isPlayBillingAvailable) {
      return <PlayBillingSubscription user={user} />;
    }

    return (
      <a
        href={`${
          process.env.NEXT_PUBLIC_STRIPE_PAYMENT_LINK
        }?client_reference_id=${encodeURIComponent(user.id)}`}
        className="duration-200 btn btn-primary block"
      >
        Assinar Agora
      </a>
    );
  };

  return (
    <div
      className={clsx(
        "duration-300 flex flex-col w-full bg-white rounded-2xl shadow-xl overflow-hidden transform transition-all",
        isHighlighted
          ? "md:w-1/2 border-2 z-10 border-primary-200"
          : "md:w-1/3 border border-gray-100"
      )}
    >
      {isHighlighted && (
        <div className="py-2 text-center text-white font-bold bg-primary-500">
          Recomendado
        </div>
      )}
      <div className="p-8">
        <div className="flex items-center mb-4">
          <span
            className={clsx(
              "text-2xl font-bold",
              type === "free" ? "text-emphasis-low" : "text-emphasis-high"
            )}
          >
            {title}
          </span>
        </div>

        <div className="mb-6">
          <span
            className={clsx(
              "text-5xl font-bold",
              type === "free" ? "text-emphasis-medium" : "text-emphasis-high"
            )}
          >
            {price}
          </span>
          {type !== "free" && (
            <span className="text-gray-700 ml-1 text-lg">/ mês</span>
          )}
        </div>

        <p className="text-gray-800 mb-6 text-lg">{description}</p>

        {features && (
          <div className="my-6 pt-6 border-t border-gray-100">
            <h4 className="text-gray-900 mb-4 font-semibold">
              O que está incluído:
            </h4>
            <ul className="space-y-3">
              {features.map((feature, index) => (
                <li
                  key={index}
                  className="flex items-center text-emphasis-medium"
                >
                  <FiCheckCircle
                    className={clsx(
                      "flex-shrink-0 mr-3",
                      type === "free" ? "text-gray-600" : "text-primary-500"
                    )}
                  />
                  {feature}
                </li>
              ))}
            </ul>
          </div>
        )}

        {type !== "free" && renderSubscriptionButton()}

        {type !== "free" && (
          <span className="block mt-4 text-center text-emphasis-low text-sm">
            Sem fidelidade. Cancele a qualquer momento.
          </span>
        )}
      </div>
    </div>
  );
}
